import StorageService from './storage-service';

/**
 * Local storage service
 */
class LocalStorageService extends StorageService {
  constructor() {
    super(window.localStorage);
  }
}

export default new LocalStorageService();
